import styled from "styled-components";

// On-pathway ($onPath) cards get a light green tint (per feedback: "visible
// in light shaded green background along with tags of critical, open");
// off-pathway "other high matches" cards stay plain white.
export const PositionCardStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border: 1px solid ${(p) => (p.$onPath ? "#A7D8A0" : (p.theme?.colors?.border ?? "#D8DAE5"))};
  border-radius: 6px;
  margin-bottom: 8px;
  cursor: ${(p) => (p.$disabled ? "default" : "pointer")};
  background: ${(p) => (p.$onPath ? "#EAF7E8" : "#fff")};
  &:hover {
    border-color: ${(p) =>
      p.$disabled
        ? (p.$onPath ? "#A7D8A0" : (p.theme?.colors?.border ?? "#D8DAE5"))
        : (p.theme?.colors?.primary ?? "#008080")};
  }
`;

export const PositionMetaStyled = styled.div`
  display: flex;
  gap: 14px;
  align-items: center;
  font-size: 12px;
  color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
`;

export const OtherMatchesHeadingStyled = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
  margin: 16px 0 8px;
`;

export const PathwayFilterRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 16px 24px 0;
  padding: 10px 16px;
  background: #fff;
  border: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  border-radius: 8px;
  font-size: 12.5px;

  .label {
    font-weight: 600;
    color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
  }
`;

export const SummaryBarStyled = styled.div`
  margin: 16px 24px 0;
  padding: 12px 16px;
  background: ${(p) => p.theme?.colors?.secondary ?? "#DDEAEA"};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12.5px;
`;

export const StepChainStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
`;

export const StepNodeStyled = styled.span`
  font-size: 11.5px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 5px;
  background: ${(p) => (p.$current ? (p.theme?.colors?.secondary ?? "#DDEAEA") : p.theme?.colors?.light ?? "#F7F7F7")};
  border: 1px solid ${(p) => (p.$target ? (p.theme?.colors?.primary ?? "#008080") : p.theme?.colors?.border ?? "#D8DAE5")};
  color: ${(p) => (p.$target ? (p.theme?.colors?.primary ?? "#008080") : p.theme?.colors?.dark ?? "#2B3034")};

  .tenure {
    font-weight: 400;
    color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
  }
`;

export const StepArrowStyled = styled.span`
  font-size: 11px;
  color: ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
`;

export const OpenPositionsHeadingStyled = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
  margin-bottom: 8px;
`;
